import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, } from 'redux-form';
import { FormFieldHelpers as Form } from '../../../../../helpers/index';
import { isValidPhoneNumber } from 'react-phone-number-input';
import validate from '../../../../../helpers/SyncValidator';
import ThanksModal from '../../../../common/elements/ThanksModal';
import Loader from '../../../../common/elements/Loader';

class ContactDetailsForm extends Component {

    state = {
        isOpen: false,
        good_phone: true,
        first_name: this.props.account.first_name,
        last_name: this.props.account.last_name,
    }

    componentWillMount() {
        const { account } = this.props, { phone_number } = account, isValid = isValidPhoneNumber(phone_number);
        account && this.handleInitialise() && this.setState({ good_phone: isValid })
    }

    componentWillReceiveProps(nextProps) {
        this.props.account.loading === true && nextProps.account.loading === false && this.setState({ isOpen: true })
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleInitialise = () => {
        const { first_name, last_name, email_address, phone_number, gender } = this.props.account;
        const formattedNumber = phone_number !== null && ((phone_number.slice(0, 1) === '+') ? phone_number : '+' + phone_number);
        const initialValues = {
            "first_name": first_name,
            "last_name": last_name,
            "email_address": email_address,
            "phone_number": formattedNumber,
            "gender_id": gender ? { label: gender.name, value: gender.id } : { label: 'Prefer not to say', value: 3 },
        };

        this.props.initialize(initialValues);
    }

    handleOnClose = (e) => {
        e.preventDefault();
        this.setState({ isOpen: false });
    }

    handleSubmitContactDetails = (contactDetails) => {
        const { handleFormSubmit } = this.props;
        this.setState({ good_phone: true });
        handleFormSubmit(contactDetails);
    }

    render() {
        const {
            submitting,
            handleSubmit,
            account
        } = this.props;

        const sexes = [{ "id": 1, "name": "Male" }, { "id": 2, "name": "Female" }, { 'id': 3, 'name': 'Prefer not to say' }];

        return (
            <div>
                <form className="row form-settings-basic legacy-input" onSubmit={handleSubmit(this.handleSubmitContactDetails)}>
                    <div className="col-xs-12 col-md-6">
                        <div className="field-box">
                            <Field
                                name="first_name"
                                label="First Name"
                                placeholder="First Name"
                                component={Form.textField}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="field-box">
                            <Field
                                name="last_name"
                                label="Last Name"
                                placeholder="LastName"
                                component={Form.textField}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <div className="field-box">
                            <Field
                                name="email_address"
                                label="Email"
                                placeholder="Email Address"
                                disabled={true}
                                component={Form.textField}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <div className="field-box">
                            <Field
                                name="phone_number"
                                label="Phone Number"
                                placeholder="Enter contact telephone number"
                                component={Form.phoneField}
                                validatePhone={(e) => this.setState({ good_phone: e })}
                            />

                            {!this.state.good_phone && <br />}
                            {!this.state.good_phone && <div className="alert alert-danger small">Incorrect phone number.</div>}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <div className="field-box">
                            <Field
                                name="gender_id"
                                label="Gender"
                                component={Form.selectField}
                                options={
                                    sexes.map((selection) => {
                                        return {
                                            value: selection.id,
                                            label: selection.name,
                                        }
                                    })
                                }
                            />

                        </div>
                    </div>
                    <div className="col-xs-12">
                        {account.loading ? <Loader /> : (
                            <ul className="buttons-left">
                                <li>
                                    <button action="submit" disabled={submitting} className="theme-button">
                                        Save settings
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                </form>

                <ThanksModal isOpen={this.state.isOpen} onClose={(e) => this.handleOnClose(e)}
                    message="Your settings have been submitted." />
            </div>

        )
    }
}

ContactDetailsForm.propTypes = {
    account: PropTypes.object,
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func
}

ContactDetailsForm = reduxForm({ form: 'contactDetails', validate })(ContactDetailsForm);

export default ContactDetailsForm;


// WEBPACK FOOTER //
// src/client/components/site/features/account/basic/ContactDetailsForm.js